import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryCards() {
  return (
    <section className="w-full px-4 md:px-6 py-16 md:py-20 bg-background-100">
      <div className="text-center mb-12">
        <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-3">
          内容分类导航
        </h2>
        <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
          五大核心板块，覆盖十八禁内容合规的各个维度，助您系统了解相关知识
        </p>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-4 md:gap-5">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group block p-5 md:p-6 rounded-xl bg-background-50 border border-background-200/70 transition-all duration-300 hover:border-primary-300 hover:bg-primary-50/30 cursor-pointer"
          >
            <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4 group-hover:bg-accent-200 transition-colors duration-200">
              <i className={`${cat.icon} text-xl`}></i>
            </div>
            <h3 className="text-base font-semibold font-heading text-foreground-900 mb-2">
              {cat.name}
            </h3>
            <p className="text-sm text-foreground-500 leading-relaxed mb-3 line-clamp-3">
              {cat.description}
            </p>
            <span className="text-xs text-accent-600 font-medium whitespace-nowrap">
              {cat.articleCount} 篇文章 &rarr;
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}